module.exports = __webpack_public_path__ + "assets/ae587e907ff1a289de345bfc36f0a40f.png";